<template>
  <div>
    <buttonlist ref="SetBtn" @help="help" @add="add" @reflash="reflash" @save="save" ></buttonlist>
    <el-table
            id="xpane-0"
            :data="dataSet"
            v-loading="loading"
            :highlight-current-row="true"
            show-overflow-tooltip="true"
            border
            stripe
            size="mini"
            :height="tableHeight"
            header-row-class-name="headerclass"
            style="width: 100%; margin-top:0px"
            :header-cell-style="$limits.headerClass"
    >
      <el-table-column type="selection" v-if="false"></el-table-column>
      <el-table-column show-overflow-tooltip prop="groupid" :label="$t('getapi[3216]')" width="200" v-if="false"></el-table-column>
      <el-table-column show-overflow-tooltip prop="groupname" :label="$t('getapi[3217]')" width="200"></el-table-column>
      <el-table-column show-overflow-tooltip prop="remarks" :label="$t('getapi[143]')" width="200"></el-table-column>
      <el-table-column :label="$t('getapi[6048]')" width="80">
        <template slot-scope="scope">
          <el-button @click.native.prevent="editInfo(scope.row)" type="text" size="small">{{
            $t('getapi[34]') }}
          </el-button>
          <el-button @click.native.prevent="del(scope.row.groupid)" type="text" size="small">{{
            $t('getapi[40]') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog v-dialogDrag :visible.sync="isShowDetail" width="50%" top="50px" @close="isShowDetail = false">
      <div style="width:100%;margin-top: 30px">
        <div style="width:100%;display: flex;">
          <div style="width:30%">
            <div>
              <div  style="height:300px">
                <el-divider content-position="left">{{$t('getapi[3543]')}}</el-divider>
                <table>
                  <tr>
                    <td>{{$t('getapi[3216]')}}</td>
                    <td>
                      <el-input v-model="dataDetail.groupid" type="text" size="mini" :disabled="true"></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td>{{$t('getapi[3217]')}}</td>
                    <td>
                      <el-input v-model="dataDetail.groupname" type="text" size="mini" :disabled="IsAdd != 2"></el-input>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div style="width:70%">
            <div>
              <el-divider content-position="left">{{$t('getapi[3547]')}}</el-divider>
            </div>
            <div style="height:600px;overflow: scroll" id="searchtree-eletree">
              <el-tree ref="tree"
                       class="filter-tree"
                       :data="detailDataTree"
                       :props="detailDefaultProps"
                       show-checkbox
                       check-strictly
                       highlight-current
                       node-key="id"
                       :default-checked-keys="defaultchecked"
                       :default-expanded-keys="defaultEexpandedkeys"
                       @check="handleCheck"></el-tree>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
				<el-button @click="isShowDetail = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="save">{{$t('getapi[937]')}}</el-button>
			</span>
    </el-dialog>
  </div>

</template>
<script>
  import Sortable from 'sortablejs';
  import Common from "@/components/Common";
  import Array from "@/components/Array";
  import CommonHeader from "@/components/CommonHeader";
  export default {
    name: "docrole",
    data() {
      let curheight = window.innerHeight - 30; // 主表高度,

      return {
          tableHeight: curheight, // 主表高度,
          dataSet:[],
          id:'',
          loading: false,
          isShowDetail: false,
          dataDetail:{},
          defaultEexpandedkeys:[],
          defaultchecked:[],
          detailDataTree:[],
          detailDefaultProps: {
              children: 'Children',
              label: 'node_name',
              father_node_id:"father_node_id",
              node_id:"node_id",
              id:"id",
              ischeck:'ischeck',
              visiable:'visiable'
          },
          IsAdd:1,
      }
    },
    mounted: function () {
        let that = this
        that.getView();
        that.authority();
    },
    methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1072]"),this.$t("getapi[79]"));
        },
        authority(){
            let that = this
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetButtonEnable('create,search,refresh');
        },
        getView(){
            let that = this
            that.$http.urlpost('/webdoc/doc/GetDocRoleGroupsList', '', function (res) {
                if (res.Success == 1) {
                    that.dataSet = res.DataContent;
                    that.authority();
                }
            });
        },
        add(){
            let that = this
            that.IsAdd = 2
            that.isShowDetail = true
            let parm = {
                Id: 0,
                fromname: "",
                LangType: that.$processdata.getLang()
            }
            that.$http.urlpost('/webdoc/doc/GetDocRoleAuthorityList', parm, function (res) {
                if (res.Success == 1) {
                    that.dataDetail = {
                        groupid:'',
                        groupname:''
                    }
                    that.detailDataTree = res.DataContent.RoleList
                    that.tickMenuIdFilter().filter(that.detailDataTree);
                }
            });
        },
        reflash(){
            let that = this
            that.getView()
        },
        editInfo(row){
            let that = this
            that.IsAdd = 1
            let parm = {
                Id: row.groupid,
                fromname: "",
                LangType: that.$processdata.getLang()
            }
            that.$http.urlpost('/webdoc/doc/GetDocRoleAuthorityList', parm, function (res) {
                if (res.Success == 1) {
                    that.isShowDetail = true
                    that.dataDetail = {
                        groupid:row.groupid,
                        groupname:row.groupname
                    }
                  that.detailDataTree = res.DataContent.RoleList
                  that.tickMenuIdFilter().filter(that.detailDataTree);
                }
            });
        },
        save(){
            let that = this
            let parm = {
                IsAdd: that.IsAdd ,
                groupid: that.dataDetail.groupid,
                groupname: that.dataDetail.groupname,
                Lists: that.detailDataTree
            }
            that.$http.urlpost('/webdoc/doc/SaveDocRoleAuthorityList', parm, function (res) {
                if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    that.isShowDetail = false
                    that.getView()
                }
            });
        },
        handleSelectionChange(val) {
            let that = this;
            that.selectData = val;
        },
        del(id){
            let that = this
            this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning'
            })
                .then(() => {
                    let parm = {
                        Id:id,
                        IsConfirm: 0
                    }
                    that.$http.urlpost('/webdoc/doc/DelDocRoleInfo', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.getView();
                        } else if(res.Success == 2){
                            that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                                confirmButtonText: that.$t('getapi[1146]'),
                                cancelButtonText: that.$t('getapi[2054]'),
                                type: 'warning'
                            })
                                .then(() => {
                                    let parm = {
                                        Id:id,
                                        IsConfirm: 1
                                    }
                                    that.$http.urlpost('/webdoc/doc/DelDocRoleInfo', parm, function (res) {
                                        if (res.Success == 1) {
                                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                            that.getView();
                                        }
                                    });
                                })
                                .catch(() => {
                                    this.$message({
                                        type: 'info',
                                        message: that.$t('getapi[6096]')
                                    });
                                });
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: that.$t('getapi[6096]')
                    });
                });
        },
        tickMenuIdFilter: function() {
            let that = this
            that.defaultchecked = [];
            let parentPerIDArr = []
            let getTickMenuId = function(obj) {
                if (undefined == obj || null == obj || obj.length == 0) {
                    return;
                }
                obj.node_name = ((!that.$limits.fnIsEmpty(obj.field_langid) && !isNaN(obj.field_langid))?(that.$t('getapi['+ obj.field_langid +']')):obj.node_name)
                if (obj.ischeck == true) {
                    that.defaultchecked.push(obj.id);
                }
                if (null != obj.Children && obj.Children.length != 0) {
                    for (let child of obj.Children) {
                        getTickMenuId(child);
                    }
                }
            };
            return {
                filter: function(arr) {
                    if (arr.length == 0) {
                        return false;
                    }
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    that.$refs.tree.setCheckedKeys(that.defaultchecked)
                    return that.defaultchecked;
                }
            };
        },
        handleCheck(data,checked){
            let that = this
            let arr = checked.checkedKeys
            let isChecked = false
            for(let i=0;i<arr.length;i++){
                if(arr[i] == data.id){
                    isChecked = true
                    break
                } else {
                    isChecked = false
                }
            }
            if(isChecked == true){
                if(data.Children == null) { // 勾选子节点
                    data.ischeck = true
                    let parentid = data.father_node_id
                    that.recursivetrueSon().filter(that.detailDataTree,parentid)
                } else {
                    that.recursivetrue().filter(data)
                }

                setTimeout(() => {
                    that.tickMenuIdFilter().filter(that.detailDataTree);
                }, 100);
                console.log(that.detailDataTree)
            } else {
                if(data.Children == null) {
                    data.ischeck = false
                    let parentid = data.father_node_id
                    that.recursivetrueCancelSon().filter(that.detailDataTree,parentid)
                } else {
                    that.recursivetrueCancel().filter(data)
                }
                that.tickMenuIdFilter().filter(that.detailDataTree);
            }
        },
        recursivetrue: function(){
            let that = this
            let recursiveArray = function(arr){
                arr.ischeck = true
                if (null != arr.Children && arr.Children.length != 0) {
                    for (let array of arr.Children) {
                        recursiveArray(array)
                    }
                }
            }
            return{
                filter:function(data){
                    if(data.length == 0){
                        return false
                    }
                    data.ischeck = true
                    recursiveArray(data)
                    return that.detailDataTree
                }
            }
        },
        recursivetrueCancel: function(){
            let that = this
            let recursiveArray = function(arr){
                arr.ischeck = false
                if (null != arr.Children && arr.Children.length != 0) {
                    for (let array of arr.Children) {
                        recursiveArray(array)
                    }
                }
            }
            return{
                filter:function(data){
                    if(data.length == 0){
                        return false
                    }
                    data.ischeck = false
                    recursiveArray(data)
                    return that.detailDataTree
                }
            }
        },
        recursivetrueSon:function(){
            let that = this
            let id = ""
            let recursiveArray = function(arr){
                if(null != arr.Children && arr.Children.length != 0 && arr.node_id == id){
                    arr.ischeck= true
                }
                if(null != arr.Children && arr.Children.length != 0){
                    for (let array of arr.Children){
                        recursiveArray(array)
                    }
                }
            }
            return{
                filter:function(data,parentid){
                    id = parentid
                    if(data.length == 0){
                        return
                    }
                    for (let rootMenu of data) {
                        recursiveArray(rootMenu)
                    }
                    return that.detailDataTree
                }
            }
        },
        recursivetrueCancelSon:function(){
            let that = this
            let id = ""
            let recursiveArray = function(arr){
                if(null != arr.Children && arr.Children.length != 0 && arr.node_id == id){
                    arr.ischeck= false
                    for(let i = 0;i<arr.Children.length;i++){
                        if(arr.Children[i].ischeck == true){
                            arr.ischeck = true
                            return
                        }
                    }
                }
                if(null != arr.Children && arr.Children.length != 0){
                    for (let array of arr.Children){
                        recursiveArray(array)
                    }
                }
            }
            return{
                filter:function(data,parentid){
                    id = parentid
                    if(data.length == 0){
                        return
                    }
                    for (let rootMenu of data) {
                        recursiveArray(rootMenu)
                    }
                    return that.detailDataTree
                }
            }
        },
    }
  };
</script>

<style scoped lang="less">
  table {
    border-collapse: separate;
    border-spacing: 0px 5px;
    td {
      padding-left: 3px;
      white-space: pre;
    }
  }
  .el-form--inline .el-form-item {
    display: flex;
  }

  .tb-edit .el-input {
    display: none
  }

  .tb-edit .current-row .el-input {
    display: block;
  }

  .tb-edit .current-row .el-input + span {
    display: none
  }

  .el-table .hidden-row {
    display: none;
  }
  /deep/.el-scrollbar__wrap{
    overflow: scroll;
    overflow-y: scroll;
  }
</style>